(function () {
    'use strict';

    angular
        .module('glossaryTermEditRoutes', [
            'glossaryTermEditModule',
            'glossaryTermModule'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {

        $stateProvider

              // GlossaryTerm Add
              .state('glossaryTermAdd', {
                  url: '/GlossaryTerm/Add',
                  templateUrl: require('./GlossaryTermAdd.tpl.html'),
                  controller: 'GlossaryTermAddController'
              })

             // GlossaryTerm Not Exists
             .state('glossaryTermNotExists', {
                 url: '/GlossaryTerm/{GlossaryTermID:int}/NotExists',
                 templateUrl: require('./glossaryTermNotExists.tpl.html')
             })

             // GlossaryTerm Edit
             .state('glossaryTerm', {
                 url: '/GlossaryTerm/{GlossaryTermID:int}',
                 params: historyCtxtServiceProvider.getStateParamsConfig(),
                 resolve: {
                     glossaryTerm: ['$stateParams', 'glossaryTermService', function ($stateParams, service) {
                         return service.getGlossaryTerm($stateParams.GlossaryTermID);
                     }],
                 },
                 views: {
                     '': {
                         template: '<div ui-view="mainContent"></div>',
                         controller: 'GlossaryTermEditController',
                     },
                     'mainContent@glossaryTerm': {
                         templateUrl: require('./GlossaryTermEdit.tpl.html')
                     }
                 }
             });

        // History Context
        historyCtxtServiceProvider.setCtxtState('glossaryTerm',
            '/app/Main/grcEdit/glossaryTerm/GOVHistoryCtxtDirective-glossaryTerm.tpl.html'
        );
    }
})();
